import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';

@Injectable()
export class NoticesProvider {

	URL = environment.ismUrl;

  constructor(public http: HttpClient, private storage: Storage) {
    console.log('Hello NoticesProvider Provider');
  }

  getNotices(category = ""){
	  return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/myNotices`,val)+`&category=${category}`).toPromise();
      }
    });
  }
  getEvents(category = "EVENT"){
	  return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/myNotices`,val)+`&category=${category}`).toPromise();
      }
    });
  }

  markRead(data: any){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<Response>(this.getUrl(`/notice/markread`,val), {
          id: data
        }).toPromise();
      }
    });
  }

  markAllRead(){
    return this.getToken().then((val) => {
      if(val){
        return this.http.put<Response>(this.getUrl(`/notice/markallread`,val), {}).toPromise();
      }
    });
  }

  submitFeedback(subject: string, desc: string){
    return this.getToken().then((val) => {
      if(val){
        return this.http.post<Response>(this.getUrl(`/sendFeedback`,val), {
          emailSubject: subject,
          emailBody: desc
        })
        .toPromise();
      }
    });
  }

  getSocietyImages(){
	  return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/getsocietyimages`,val)).toPromise();
      }
    });
  }

  getConstant(type){
    return this.getToken().then((val) => {
      if(val){
        return this.http.get<Response>(this.getUrl(`/society/${val.societyId}/constant`,val)+`&type=${type}`).toPromise();
      }
    });
  }

  getToken(){
    return this.storage.get("loginDetails");
  }

  getUrl(link: string, val: any):string {
    return `${this.URL}${link}?api-token=${val.api_token}&user-id=${val.id}`;
  }

}

export class Response{
  constructor(res){
    console.log(res);
  }
  status: string;
  message: string;
  data?: any;
  metadata?: any;
  complaintTypeList?: any;
}



// WEBPACK FOOTER //
// ./src/providers/notices/notices.ts